/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type Rating = 0 | 1 | 2 | 3 | 4 | 5;

export const Rating = {
    NUMBER_0: 0 as Rating,
    NUMBER_1: 1 as Rating,
    NUMBER_2: 2 as Rating,
    NUMBER_3: 3 as Rating,
    NUMBER_4: 4 as Rating,
    NUMBER_5: 5 as Rating
};
